module.exports = __webpack_public_path__ + "img/icon_footer_02.8fce9002.png";